<template>
  <v-dialog v-model="dialog" scrollable fullscreen>
    <v-card>
      <v-toolbar dense color="primary" dark tabs>
        <v-toolbar-title>
          {{
            selected._id
              ? $t('titles.global.updateModel', {
                  field: $tc('models.stadium'),
                })
              : $t('titles.global.newModel', { field: $tc('models.stadium') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
        <v-tabs
          slot="extension"
          v-model="tab"
          color="primary"
          slider-color="white"
          centered
        >
          <v-tab>{{ $tc('models.stadium') }}</v-tab>
          <v-tab :disabled="!selected._id">
            {{ $tc('models.pitch', 2) }}
          </v-tab>
          <v-tab :disabled="!selected._id">
            {{ $tc('models.camera', 2) }}
          </v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item ripple>
            <tab-information ref="tabInformation" @close="cancel" />
          </v-tab-item>
          <v-tab-item ripple>
            <tab-pitches :stadium-id="selected._id" stadium-view />
          </v-tab-item>
          <v-tab-item ripple>
            <tab-cameras :stadium-id="selected._id" stadium-view />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TabCameras from '../cameras/Dashboard'
import TabPitches from '../pitches/Dashboard'
import TabInformation from './TabInformation'

export default {
  name: 'StadiumForm',
  components: {
    TabInformation,
    TabPitches,
    TabCameras,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
  },
  computed: {
    ...mapState({
      selected: (state) => state.stadiums.selected,
    }),
  },
  methods: {
    ...mapActions({
      reset: 'stadiums/reset',
      // resetPitchState: 'pitches/resetState'
    }),
    cancel() {
      this.$emit('close')
      this.clear()
    },
    clear() {
      this.$nextTick((_) => {
        this.reset()
        this.tab = 0
        // this.resetPitchState()
        if (this.$refs.tabInformation) this.$refs.tabInformation.clear()
      })
    },
  },
}
</script>
